export default __webpack_public_path__ + "static/media/defaultSort.9b46c8e9.svg";